import { Button } from '@avanta/shared/components/ui/Button';
import { Textarea } from '@avanta/shared/components/ui/Textarea';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useIsMutating } from '@tanstack/react-query';
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { MUTATION_KEYS } from 'constants/common';
import {
  AppointmentsReservePayload,
  type StepProps,
} from 'pages/Appointments/AppointmentsReserve/types';
import { BackButton } from '../../../ui/BackButton';
import { PsychoCard } from '../../../ui/PsychoCard';
import { SessionSummary } from '../../../ui/SessionSummary';
import { StepSection } from '../../../ui/StepSection';
import { Pack } from './Pack';
import { CONFIRMATION_STEPS_KEY_PREFIX } from '.';

export const MobileView = ({ handleBack }: StepProps): React.ReactElement => {
  const { watch } = useFormContext();
  const [psychologist, selectedPack] = watch([
    AppointmentsReservePayload.psychologist,
    AppointmentsReservePayload.selectedPack,
  ]);
  const isPendingEdit = useIsMutating({ mutationKey: [MUTATION_KEYS.UPDATE_APPOINTMENT] }) > 0;
  const isPendingBook = useIsMutating({ mutationKey: [MUTATION_KEYS.BOOK_APPOINTMENT] }) > 0;
  const isPending = isPendingEdit || isPendingBook;
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  const commentsLabel = (
    <Trans
      ns={LOCIZE_NS.APPOINTMENTS}
      i18nKey={`${CONFIRMATION_STEPS_KEY_PREFIX}commentsLabel`}
      components={{
        span: <span className="text-gray-400 text-xs am-lg:text-sm font-normal" />,
      }}
    />
  );

  return (
    <div className="am-lg:hidden w-full ">
      <StepSection
        title={t(`${CONFIRMATION_STEPS_KEY_PREFIX}resumeLabel.regular`)}
        className="flex flex-col gap-4 pb-4"
      >
        <SessionSummary />
        <PsychoCard psychologist={psychologist} className="shadow-none" />
        {selectedPack && <Pack />}
        <StepSection
          title={commentsLabel}
          className="flex flex-col gap-2"
          containerClassName="gap-2"
        >
          <p className="text-sm text-denim-800 leading-4">
            {t(`${CONFIRMATION_STEPS_KEY_PREFIX}commentsDescription`)}
          </p>
          <Textarea
            placeholder={t(`${CONFIRMATION_STEPS_KEY_PREFIX}observations.placeholder`)}
            className="min-h-18"
          />
        </StepSection>
        <div className="flex flex-col gap-4 w-full mt-4">
          <Button
            type="submit"
            variant="primary"
            size="lg"
            className="w-full"
            isLoading={isPending}
          >
            {t(`${CONFIRMATION_STEPS_KEY_PREFIX}onSubmit`)}
          </Button>
          <BackButton handleBack={handleBack} className="w-full" />
        </div>
      </StepSection>
    </div>
  );
};
